import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./institution.actions";
import * as fromGraphql from "./institution.graphql";
import {PaginationService} from "../../../../services/pagination.service";
import {GET_ALL_INSTITUTIONS_FEW} from "./institution.graphql";


@Injectable()
export class InstitutionEffects {
  createInstitutionMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTITUTION,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertInstitution({ institution: result?.data })
              );
              this.notificationService.successMessage('Created Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateInstitutionMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTITUTION,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertInstitution({ institution: result?.data })
              );
              this.notificationService.successMessage('Updated Successfully');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  loadHcmisInstitutionMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadHcmisInstitutionMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.LOAD_HCMIS_INSTITUTIONS,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertInstitutions({ institutions: result?.data })
              );
              this.notificationService.successMessage('Operation Success');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });



  getAllInstitutions = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllInstitutions),
    switchMap((action) => {
      return this.apollo.query({
        query: action?.few ? fromGraphql.GET_ALL_INSTITUTIONS_FEW: fromGraphql.GET_ALL_INSTITUTIONS,
        fetchPolicy: 'network-only',
        variables:{
          filtering:action?.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching institutions'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            if (result?.response?.status) {

              // console.log(result?.page, '------ page')
              // this.paginationService.setPage({...result?.page, itemsPerPage: action?.filtering.itemsPerPage})
              this.paginationService.setPage({...result?.page, itemsPerPage: 0})
              this.store.dispatch(fromActions.loadInstitutions({institutions: result?.data}))
            }
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private paginationService: PaginationService,
  ) {}
}
